export default "__VITE_ASSET__DwVN0EO7__"